// extracted by mini-css-extract-plugin
export default {"container":"ShortcutsPage__container___Qlyzc","searchBarContainer":"ShortcutsPage__searchBarContainer___VvTuI"};